import React, { forwardRef } from "react";

import type { RadioOptionProps } from "./Radio.d";

export const RadioOption = forwardRef(function radioOption(props: RadioOptionProps, ref) {
    const {
        checked = false,
        className,
        description,
        descriptionClassName,
        descriptionOuterClassName = "pl-40",
        label,
        labelClassName = "pl-40",
        ...rest
    } = props;
    if (!description) {
        return (
            <label className={className || "flex"}>
                <input
                    type="radio"
                    checked={checked}
                    className="radio"
                    ref={ref as React.Ref<HTMLInputElement>}
                    {...rest}
                />
                <span className={`radio__label ${labelClassName}`}>{label}</span>
            </label>
        );
    }
    return (
        <label className={className || "flex"}>
            <input
                type="radio"
                checked={checked}
                className="radio"
                ref={ref as React.Ref<HTMLInputElement>}
                {...rest}
            />
            <div className={`radio__label-container ${descriptionOuterClassName}`}>
                <span className={`radio__label ${labelClassName}`}>{label}</span>
                <p className={`radio__description ${descriptionClassName}`}>{description}</p>
            </div>
        </label>
    );
});

export default RadioOption;
